import { render, staticRenderFns } from "./review-analysis.vue?vue&type=template&id=173c222b&scoped=true&"
import script from "./review-analysis.vue?vue&type=script&lang=js&"
export * from "./review-analysis.vue?vue&type=script&lang=js&"
import style0 from "./review-analysis.vue?vue&type=style&index=0&id=173c222b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173c222b",
  null
  
)

export default component.exports